var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477-172q-120 0-207.5-80T172-452h22q12 109 92 183.5T477-194q120 0 203.5-84T764-482q0-119-83.5-201.5T477-766q-59 0-112.5 24T269-676h94v22H229v-135h22v100q45-46 103.5-72.5T477-788q64 0 120 24t98 66q42 42 66.5 98T786-481q0 64-24.5 120.5t-66.5 98q-42 41.5-98 66T477-172Zm138-160L470-476v-205h22v196l139 137-16 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.0fef3e774ecc126465400840cd677cf0.svg";
export { ForwardRef as ReactComponent };